import request from "./request";

export const getRefs = async (keys: string[]) => {
  const response = await request(`/api/v1/home/refs?keys=${keys.join(',')}`, {
    method: 'GET',
  });
  return response.data.data;
}
